export const backendUri: string | undefined =
  process.env.REACT_APP_API_ENDPOINT || 'localhost:8080/'

export const accessToken: string =
  process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN || ''

export const space: string = process.env.REACT_APP_CONTENTFUL_SPACE || ''
